import { render, staticRenderFns } from "./back-list.vue?vue&type=template&id=553f10a4&scoped=true"
import script from "./back-list.vue?vue&type=script&lang=js"
export * from "./back-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553f10a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553f10a4')) {
      api.createRecord('553f10a4', component.options)
    } else {
      api.reload('553f10a4', component.options)
    }
    module.hot.accept("./back-list.vue?vue&type=template&id=553f10a4&scoped=true", function () {
      api.rerender('553f10a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/property/back-list.vue"
export default component.exports